import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { API_ROUTES } from '../config/api';
import { PaginatedResponse, SupplierRecord } from '../types/api.types';

export interface UseSuppliersListOptions {
  page?: number;
  pageSize?: number;
  enabled?: boolean;
}

/**
 * Hook to fetch paginated list of suppliers for a database
 */
export function useSuppliersList(
  databaseId: number | string | null,
  options?: UseSuppliersListOptions
) {
  const { page = 1, pageSize = 50, enabled = true } = options || {};

  return useQuery<PaginatedResponse<SupplierRecord>>({
    queryKey: ['suppliersList', databaseId, page, pageSize],
    queryFn: async () => {
      if (!databaseId) {
        throw new Error('Database ID is required');
      }

      const response = await api.get(
        `${API_ROUTES.SUPPLIERS.BASE}${API_ROUTES.SUPPLIERS.LIST(String(databaseId))}`,
        {
          params: {
            page,
            page_size: pageSize,
          },
        }
      );

      return response.data;
    },
    enabled: !!databaseId && enabled,
    staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
  });
}

